import { REGISTRATION_TERMS_HTML, REGISTRATION_TERMS_TITLE } from './registrationTermsContent';

const RULES_TR = {
  title: 'Şartlar ve Koşullar',
  html: `
<h1>ŞARTLAR VE KOŞULLAR</h1>
<p>Bu Şartlar ve Koşullar, VurgunBet (bundan sonra “Platform” veya “İşletmeci”) tarafından sunulan çevrimiçi spor bahisleri, casino ve ilgili hizmetlerin kullanımını düzenler. Platforma erişerek, hesap oluşturarak veya hizmetleri kullanarak bu metni okuduğunuzu, anladığınızı ve kabul ettiğinizi beyan edersiniz.</p>

<h2>1. Tanımlar ve kapsam</h2>
<p>Bu metin; web sitesi, mobil uygulamalar, hesap yönetimi, bahis kabulü, casino oyunları, ödemeler, promosyonlar ve müşteri desteği dahil tüm VurgunBet hizmetlerini kapsar. Hizmetler yalnızca yasal olarak kullanılmasına izin verilen yerlerde ve koşullarda sunulur. Kullanıcı, kendi yargı bölgesindeki kısıtlamaları kontrol etmekle yükümlüdür.</p>

<h2>2. Yaş ve uygunluk</h2>
<p>Hizmetler yalnızca 18 yaşını doldurmuş gerçek kişilere açıktır. Hesap açarak bu yaş şartını karşıladığınızı ve yasal ehliyete sahip olduğunuzu onaylarsınız. İşletmeci, yaş veya uygunluk doğrulaması talep edebilir; doğrulama tamamlanana kadar hesap kısıtlanabilir.</p>

<h2>3. Hesap kaydı ve güvenlik</h2>
<p>Her gerçek kişi yalnızca bir hesap açabilir. Kayıt sırasında doğru, güncel ve eksiksiz bilgi vermeniz zorunludur. Giriş bilgilerinizin gizliliğinden siz sorumlusunuz. Yetkisiz kullanımı derhal destek ekibine bildirmelisiniz. İşletmeci; çoklu hesap, kimlik sahteciliği veya güvenlik ihlali şüphesinde hesabı askıya alabilir, kapatabilir veya bakiyeyi inceleme altına alabilir.</p>

<h2>4. Kimlik doğrulama (KYC)</h2>
<p>Yasal ve operasyonel gereklilikler kapsamında kimlik, adres, ödeme aracı sahipliği ve kaynak doğrulaması istenebilir. Talep edilen belgeleri makul sürede sunmazsanız yatırım, çekim veya oyun erişimi sınırlanabilir. Sahte veya değiştirilmiş belge sunulması hesap kapatma gerekçesidir.</p>

<h2>5. Yatırımlar ve çekimler</h2>
<p>Desteklenen ödeme yöntemleri, limitler ve süreler kasa bölümünde yayınlanır. Yalnızca size ait ödeme araçlarını kullanabilirsiniz. Kazançlar oyun hesabına yatırılır; çekimler doğrulama, güvenlik kontrolleri, açık bahisler, bonus şartları ve uygulanan limitlere tabidir. Şüpheli işlemler geciktirilebilir veya reddedilebilir.</p>

<h2>6. Bahis ve casino oyunları</h2>
<p>Spor bahisleri yayınlanan oran satırına göre kabul edilir. Sonuçlandırma resmi sonuçlara ve Platform kurallarına göre yapılır. Etkinlik iptali, ertelenmesi veya teknik hata durumlarında Platform, bahisleri geçersiz sayma, iade etme veya yeniden sonuçlandırma hakkını saklı tutar. Casino oyunları ilgili sağlayıcı kurallarına ve Platform politikalarına tabidir. Açık hata (ör. bariz oran/ödeme hatası) içeren işlemler iptal edilebilir.</p>

<h2>7. Bonuslar ve promosyonlar</h2>
<p>Bonus, bedava bahis, free spin ve benzeri tekliflerin özel şartları ilgili kampanya metninde belirtilir. Çevrim şartları, maksimum bahis, yasaklı oyunlar ve çekim kısıtları uygulanabilir. Kötüye kullanım, arbitraj veya şart ihlali halinde bonus ve ilişkili kazançlar iptal edilebilir.</p>

<h2>8. Kara para aklama ve dolandırıcılık önleme</h2>
<p>Platform, kara para aklamanın önlenmesi ve dolandırıcılıkla mücadele politikaları uygular. İşlemler izlenebilir; kaynak belgesi istenebilir. Yasadışı faaliyet şüphesinde hesap dondurulabilir, yetkili mercilere bildirim yapılabilir ve fonlar bloke edilebilir.</p>

<h2>9. Sorumlu oyun</h2>
<p>Kumar eğlence amaçlıdır; gelir kaynağı değildir. Limit, mola ve kendini engelleme araçları sunulabilir. Sorunlu kumar belirtilerinde destek ile iletişime geçmeniz önerilir. 18 yaş altı kullanım kesinlikle yasaktır.</p>

<h2>10. Yasaklı davranışlar</h2>
<p>Aşağıdakiler yasaktır: bot veya otomatik yazılım kullanımı; hile, manipülasyon veya sistem zafiyetinden yararlanma; üçüncü kişiler adına hesap işletme; ödeme aracı suiistimali; hakaret veya dolandırıcılık. İhlalde bakiye incelemesi, bahis iptali ve hesap kapatma uygulanabilir.</p>

<h2>11. Fikri mülkiyet</h2>
<p>Platform içeriği, markalar, yazılım ve tasarım unsurları İşletmeciye veya lisans verenlere aittir. İzinsiz kopyalama, dağıtma veya ticari kullanım yasaktır.</p>

<h2>12. Sorumluluğun sınırlandırılması</h2>
<p>Hizmetler “olduğu gibi” sunulur. Platform; internet kesintisi, üçüncü taraf sağlayıcı hataları, cihaz uyumsuzluğu veya mücbir sebeplerden doğan dolaylı zararlardan, yürürlükteki hukukun izin verdiği ölçüde sorumlu tutulamaz. Teknik arızada etkilenen işlemler iptal veya düzeltme konusu olabilir.</p>

<h2>13. Değişiklikler</h2>
<p>İşletmeci bu şartları güncelleyebilir. Güncel metin sitede yayınlandığı anda yürürlüğe girer. Hizmetleri kullanmaya devam etmeniz güncel şartları kabul ettiğiniz anlamına gelir.</p>

<h2>14. İletişim</h2>
<p>İşletmeci: VurgunBet / VURGUN. Destek kanalları Yardım Merkezi ve site alt bilgisinde yayınlanır. Web sitesi: https://vurgunbet.com</p>
`,
};

const RULES_EN = {
  title: 'Terms and Conditions',
  html: `
<h1>TERMS AND CONDITIONS</h1>
<p>These Terms and Conditions govern use of online sports betting, casino and related services offered by VurgunBet (the “Platform” or “Operator”). By accessing the Platform, creating an account or using the services, you confirm that you have read, understood and accept this document.</p>
<h2>1. Scope</h2>
<p>These terms cover the website, mobile apps, account management, betting, casino games, payments, promotions and support. Services are available only where legally permitted. You are responsible for complying with laws applicable to you.</p>
<h2>2. Age and eligibility</h2>
<p>Services are for individuals aged 18 or over. The Operator may request age or eligibility verification and restrict the account until completed.</p>
<h2>3. Account</h2>
<p>One account per person. Information must be accurate. You are responsible for login security. Multiple accounts, fraud or security breaches may lead to suspension, closure or balance review.</p>
<h2>4. Verification (KYC)</h2>
<p>Identity, address, payment instrument ownership and source-of-funds checks may be required. Failure to provide documents may limit deposits, withdrawals or play.</p>
<h2>5. Deposits and withdrawals</h2>
<p>Methods, limits and timings are shown in the cashier. Use only payment instruments you own. Withdrawals are subject to verification, security checks, open bets, bonus rules and limits.</p>
<h2>6. Betting and casino</h2>
<p>Sports bets are accepted on the published line and settled on official results and Platform rules. Obvious errors may be voided. Casino games follow provider and Platform rules.</p>
<h2>7. Bonuses</h2>
<p>Promotion-specific terms apply, including wagering, max stake and game restrictions. Abuse may result in cancellation of bonus and related winnings.</p>
<h2>8. AML and fraud</h2>
<p>The Platform applies anti-money-laundering and anti-fraud controls. Suspicious activity may lead to account freezes and reporting where required.</p>
<h2>9. Responsible gaming</h2>
<p>Gambling is entertainment, not a source of income. Limits, breaks and self-exclusion tools may be available. Under-18 use is prohibited.</p>
<h2>10. Changes and contact</h2>
<p>The Operator may update these terms by publishing them on the website. Operator: VurgunBet / VURGUN. Website: https://vurgunbet.com. Support channels are listed in the Help Centre and footer.</p>
`,
};

const PRIVACY_TR = {
  title: 'Gizlilik Politikası',
  html: `
<h1>GİZLİLİK POLİTİKASI</h1>
<p>Bu Gizlilik Politikası, VurgunBet’in (bundan sonra “İşletmeci” veya “biz”) web sitesi ziyaretçileri ve kayıtlı kullanıcıların kişisel verilerini nasıl topladığını, işlediğini, sakladığını ve koruduğunu açıklar. Platformu kullanarak bu politikada açıklanan işlemlere ilişkin bilgilendirildiğinizi kabul edersiniz.</p>

<h2>1. Veri sorumlusu</h2>
<p>Veriler VurgunBet / VURGUN adına işletilen Platform kapsamında işlenir. İletişim: Yardım Merkezi ve https://vurgunbet.com adresinde yayınlanan destek kanalları.</p>

<h2>2. Topladığımız veriler</h2>
<ul>
<li>Kimlik ve hesap bilgileri: ad-soyad, doğum tarihi, iletişim bilgileri, kullanıcı adı, dil ve tercih ayarları;</li>
<li>Doğrulama verileri: kimlik belgesi kopyaları, adres kanıtı ve talep edilen diğer belgeler;</li>
<li>Finansal veriler: yatırım/çekim kayıtları, ödeme yöntemi bilgileri (tam kart numarası saklanmaz; ödeme sağlayıcı standartlarına uyulur);</li>
<li>Teknik veriler: IP adresi, cihaz/tarayıcı bilgisi, oturum günlükleri, yaklaşık konum sinyalleri;</li>
<li>Kullanım verileri: bahis ve oyun geçmişi, bonus kullanımı, destek yazışmaları;</li>
<li>Pazarlama tercihleri: yalnızca onay verdiğinizde.</li>
</ul>

<h2>3. İşleme amaçları</h2>
<p>Veriler şu amaçlarla işlenir: hesap oluşturma ve yönetimi; kimlik ve yaş doğrulama; bahis/casino hizmetlerinin sunulması; yatırım ve çekimlerin işlenmesi; dolandırıcılık, kötüye kullanım ve kara para aklamanın önlenmesi; yasal ve düzenleyici yükümlülüklerin yerine getirilmesi; güvenlik; müşteri desteği; onaylıysa pazarlama iletişimi; hizmet iyileştirme ve analitik.</p>

<h2>4. Hukuki dayanak</h2>
<p>İşleme; sözleşmenin ifası, yasal yükümlülükler, meşru menfaatler (güvenlik, dolandırıcılık önleme, hizmet iyileştirme) ve gerektiğinde açık rızanıza dayanır. Rızaya dayanan işlemleri istediğiniz zaman geri çekebilirsiniz; bu, rıza öncesi işlemenin hukuka uygunluğunu etkilemez.</p>

<h2>5. Çerezler ve benzer teknolojiler</h2>
<p>Platform; oturum yönetimi, güvenlik, tercih hatırlama, performans ve (onaylıysa) analitik/pazarlama için çerezler ve benzer araçlar kullanabilir. Tarayıcı ayarlarından çerezleri yönetebilirsiniz; bazı çerezler zorunlu olduğundan kapatılması hizmeti etkileyebilir.</p>

<h2>6. Üçüncü taraflar</h2>
<p>Veriler, yalnızca gerekli olduğu ölçüde şu kategorilere aktarılabilir: ödeme ve ödeme aracılık hizmetleri; oyun/bahis sağlayıcıları; kimlik doğrulama ve dolandırıcılık önleme ortakları; barındırma, bulut ve BT hizmetleri; müşteri iletişim araçları; yasal zorunluluk halinde yetkili merciler. Aktarımlar sözleşmesel ve teknik koruma önlemleriyle yapılır.</p>

<h2>7. Uluslararası aktarım</h2>
<p>Hizmetlerin doğası gereği veriler farklı ülkelerdeki sunucu veya iş ortaklarında işlenebilir. Uygun koruma seviyesi sağlanmaya çalışılır.</p>

<h2>8. Saklama süresi</h2>
<p>Veriler, işleme amacı ve yasal saklama yükümlülükleri (özellikle mali, AML ve anlaşmazlık süreleri) için gerekli olduğu sürece tutulur. Süre sonunda silinir, anonimleştirilir veya erişimi kısıtlanır.</p>

<h2>9. Güvenlik</h2>
<p>İşletmeci; erişim kontrolü, şifreleme (uygun yerlerde), günlükleme ve personel yetkilendirmesi gibi makul teknik ve idari önlemler uygular. İnternet üzerinden iletimin riskleri tamamen ortadan kaldırılamaz; şüpheli durumda hesabınızı koruyun ve destek ile iletişime geçin.</p>

<h2>10. Haklarınız</h2>
<p>Yürürlükteki hukuka bağlı olarak şu haklara sahip olabilirsiniz: erişim; düzeltme; silme; işlemeyi kısıtlama; itiraz; veri taşınabilirliği; rızayı geri çekme. Talepler destek üzerinden iletilebilir. AML, dolandırıcılık önleme veya yasal saklama gerekçeleriyle bazı talepler sınırlanabilir.</p>

<h2>11. Çocuklar</h2>
<p>Hizmetler 18 yaş altındaki kişilere yönelik değildir. Bu yaş grubuna ait olduğu anlaşılan veriler silinir ve hesap kapatılır.</p>

<h2>12. Politika değişiklikleri</h2>
<p>Bu politika güncellenebilir. Güncel sürüm sitede yayınlanır. Önemli değişikliklerde makul bildirim yöntemleri kullanılabilir.</p>
`,
};

const PRIVACY_EN = {
  title: 'Privacy Policy',
  html: `
<h1>PRIVACY POLICY</h1>
<p>This Privacy Policy explains how VurgunBet (the “Operator” or “we”) collects, uses, stores and protects personal data of website visitors and registered users.</p>
<h2>1. Controller</h2>
<p>Data is processed in connection with the Platform operated as VurgunBet / VURGUN. Contact: Help Centre and support channels published at https://vurgunbet.com.</p>
<h2>2. Data we collect</h2>
<ul>
<li>Identity and account data;</li>
<li>Verification documents when requested;</li>
<li>Payment and transaction records (card numbers are not stored in full);</li>
<li>Technical data (IP, device/browser, logs);</li>
<li>Usage data (bets, games, bonuses, support);</li>
<li>Marketing preferences where consented.</li>
</ul>
<h2>3. Purposes</h2>
<p>We process data to operate accounts, verify age/identity, provide betting and casino services, process deposits/withdrawals, prevent fraud and money laundering, meet legal duties, provide support, and (with consent) send marketing.</p>
<h2>4. Cookies</h2>
<p>Cookies and similar technologies may be used for sessions, security, preferences, performance and, where allowed, analytics/marketing. You can manage cookies in your browser; disabling essential cookies may affect the service.</p>
<h2>5. Sharing</h2>
<p>Data may be shared with payment providers, game/betting providers, verification and fraud partners, hosting/IT vendors, communication tools, and authorities where legally required.</p>
<h2>6. Retention and security</h2>
<p>Data is kept only as long as needed for the purposes and legal retention (including AML and dispute periods). Reasonable technical and organisational measures are applied.</p>
<h2>7. Your rights</h2>
<p>Depending on applicable law you may request access, correction, deletion, restriction, objection, portability or withdrawal of consent via support. Some requests may be limited by AML or legal retention duties.</p>
<h2>8. Children and updates</h2>
<p>Services are not for anyone under 18. This policy may be updated by publication on the website.</p>
`,
};

const AGREE_TR = {
  title: 'Hizmet bildirimleri için kişisel veri işleme onayı',
  html: `
<h1>Hizmet bildirimleri için kişisel veri işleme onayı</h1>
<p>Bu onayı vererek, VurgunBet’in hizmet bildirimleri göndermesi amacıyla iletişim verilerinizin işlenmesine izin verirsiniz.</p>
<h2>1. Amaç</h2>
<p>Kimlik doğrulama, güvenlik uyarıları, işlem bildirimleri ve hesapla ilgili zorunlu bilgilendirmeler.</p>
<h2>2. İşlenen veriler</h2>
<p>E-posta adresi, telefon numarası (varsa), hesap numarası / kullanıcı kimliği.</p>
<h2>3. Süre ve geri çekme</h2>
<p>Onayınızı hesap ayarlarından veya destek üzerinden geri çekebilirsiniz. Hesap güvenliği için zorunlu bildirimler devam edebilir.</p>
<p>Ayrıntılar Gizlilik Politikasında yer alır.</p>
`,
};

const AGREE_EN = {
  title: 'Consent to personal data processing for service notices',
  html: `
<h1>Consent to personal data processing for service notices</h1>
<p>By giving this consent you allow VurgunBet to process your contact details to send service-related notices (verification, security, transactions and account messages).</p>
<p>You may withdraw consent via account settings or support. Mandatory security notices may continue. See the Privacy Policy for details.</p>
`,
};

const ADVERTISING_TR = {
  title: 'Reklam ve pazarlama iletişimi koşulları',
  html: `
<h1>REKLAM VE PAZARLAMA İLETİŞİMİ KOŞULLARI</h1>
<p>Bu koşulları kabul ederek VurgunBet’ten promosyon, bonus, turnuva ve benzeri pazarlama mesajları almayı onaylarsınız.</p>
<h2>1. Kanallar</h2>
<p>E-posta, SMS, uygulama bildirimleri ve kayıt sırasında belirtilen diğer kanallar.</p>
<h2>2. Geri çekme</h2>
<p>Onayı hesap ayarlarından veya destek üzerinden istediğiniz zaman geri çekebilirsiniz. Reddetmek ana hizmetlere erişimi engellemez.</p>
<h2>3. Veriler</h2>
<p>İletişim bilgileriniz Gizlilik Politikasına uygun işlenir.</p>
`,
};

const ADVERTISING_EN = {
  title: 'Advertising mailing terms',
  html: `
<h1>ADVERTISING MAILING TERMS</h1>
<p>By accepting these terms you consent to receive promotional messages from VurgunBet about bonuses, offers and events via email, SMS, push and other channels indicated at registration.</p>
<p>You may withdraw consent at any time in account settings or via support. Refusal does not affect access to core services. Contact details are processed under the Privacy Policy.</p>
`,
};

export const LEGAL_PAGES = {
  'promotion-terms': {
    title: REGISTRATION_TERMS_TITLE,
    html: REGISTRATION_TERMS_HTML,
  },
  rules: {
    tr: RULES_TR,
    en: RULES_EN,
  },
  agree: {
    tr: AGREE_TR,
    en: AGREE_EN,
  },
  persdata: {
    tr: PRIVACY_TR,
    en: PRIVACY_EN,
  },
  advertising: {
    tr: ADVERTISING_TR,
    en: ADVERTISING_EN,
  },
};

export function getLegalPage(id, locale = 'tr') {
  const page = LEGAL_PAGES[id];
  if (!page) return null;
  if (typeof page.html === 'string') return page;
  const key = String(locale || 'tr').toLowerCase().startsWith('en') ? 'en' : 'tr';
  return page[key] || page.tr || page.en || null;
}
